export default function readibleAbnString(n) {
  if (n)
    return `${n?.substring(0, 2)} ${n?.substring(2, 5)} ${n?.substring(
      5,
      8
    )} ${n?.substring(8, 11)}`;
}